import { render, staticRenderFns } from "./erp-order.vue?vue&type=template&id=16e47111&scoped=true"
import script from "./erp-order.vue?vue&type=script&lang=ts"
export * from "./erp-order.vue?vue&type=script&lang=ts"
import style0 from "./erp-order.vue?vue&type=style&index=0&id=16e47111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e47111",
  null
  
)

export default component.exports